import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';

const NotFound = () => {
  useSeo(null);

  return (
    <section className="container-site flex min-h-[80vh] flex-col items-start justify-center pt-24">
      <p className="eyebrow">Error 404</p>
      <h1 className="mt-4 font-display text-4xl font-bold text-white md:text-6xl">No signal on this page.</h1>
      <p className="mt-4 max-w-md text-slate-400">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="btn-primary mt-8">
        Back to home
      </Link>
    </section>
  );
};

export default NotFound;
